import { render, staticRenderFns } from "./bloggerPos.vue?vue&type=template&id=8c34bff4&scoped=true&"
import script from "./bloggerPos.vue?vue&type=script&lang=js&"
export * from "./bloggerPos.vue?vue&type=script&lang=js&"
import style0 from "./bloggerPos.vue?vue&type=style&index=0&id=8c34bff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c34bff4",
  null
  
)

export default component.exports